var map = {
	"./cart.svg": "Iago",
	"./downSolid.svg": "sk7Z",
	"./fu.svg": "0+rq",
	"./kong.svg": "P2WC",
	"./oldpeople.svg": "7phg",
	"./paycard01.svg": "EpKg",
	"./pop_b.svg": "CrGk",
	"./pop_b_a.svg": "9DB0",
	"./pop_t.svg": "GRwO",
	"./pop_t_a.svg": "yQyL",
	"./time.svg": "dUKR",
	"./workcare.svg": "hgld"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "undn";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon nonrecursive \.svg$
// module id = undn
// module chunks = 55